module.exports = __webpack_public_path__ + "img/step3-b.edbc2420.png";